<template>
  <div id="app">
    <component :is="'default-layout'">
      <router-view :key="$route.path"></router-view>
    </component>
  </div>
</template>

<script>
import DefaultLayout from "./layouts/Default.vue";

export default {
  components: {
    DefaultLayout,
  },
  name: "app",
  metaInfo: {
    title: "Bewertungsportal für Seminarteilnehmer",
  },
};
</script>

<style>
body {
  background-color: #eee !important;
  font-family: "WeiterSans", sans-serif !important;
}

@font-face {
  font-family: "WeiterSans";
  src: url("@/assets/fonts/WeiterSans-Medium.woff2") format("woff2"),
    url("@/assets/fonts/WeiterSans-Medium.woff") format("woff");
  font-weight: 500;
  font-style: normal;
}

@font-face {
  font-family: "WeiterSans";
  src: url("@/assets/fonts/WeiterSans-Regular.woff2") format("woff2"),
    url("@/assets/fonts/WeiterSans-Regular.woff") format("woff");
  font-weight: 400;
  font-style: normal;
}

@font-face {
  font-family: "WeiterSans";
  src: url("@/assets/fonts/WeiterSans-SemiBold.woff2") format("woff2"),
    url("@/assets/fonts/WeiterSans-SemiBold.woff") format("woff");
  font-weight: 600;
  font-style: normal;
}

#app {
  padding-top: 40px;
}

#app h4 {
  font-size: 18px;
}
#app legend {
  font-size: 21px;
  border: none;
  margin: 10px 0;
  font-weight: 500;
}
.marked {
  position: relative;
  border-radius: 100%;
  padding: 3px 6px;
  margin: 0 -6px;
  border: 3px solid #fdc41f;
}

.question-container-style {
  display: inline-flex;
  width: 100%;
  align-items: baseline;
}

.question-label-style {
  font-size: 1.1em;
  font-weight: 500;
  color: #033878;
  margin-bottom: 1rem;
  flex: 1;
}

.shorter-width {
  margin: auto;
  width: 65%;
}

.form-group-label-style {
  color: #033878;
}

.primary-text-color {
  color: #033878;
}

.form-step-circle {
  background: #fdc41f;
  width: 1.4em;
  height: 1.4em;
  display: inline-block;
  border-radius: 100%;
  text-align: center;
  margin-right: 0.5em;
  color: #042b60;
  font-weight: 400;
  line-height: 1.4em;
  flex-shrink: 0;
}

#app label {
  font-weight: normal;
}
.rating-template {
  display: none;
}
.page-header__title small {
  color: #f8f8f8;
}
.room-template {
  display: none;
}
.room {
  display: initial;
}
a.room {
  text-decoration: none;
}
.container-fluid {
  max-width: 1240px;
}
.table-row {
  display: table;
  margin: -30px;
}
.table-col {
  display: table-cell;
}
.sample-reviews {
  background: #f1f8f7;
  padding: 30px;
  margin: -30px -30px -30px 0;
}
.sample-reviews h3 {
  color: #042b60;
  margin-bottom: 15px;
  margin-top: 30px;
}
.sample-reviews p {
  color: #042b60;
  margin-bottom: 5px;
  margin-top: 5px;
  font-size: 17px;
}
.sample-reviews .box {
  background: #fff;
  padding: 15px;
  color: #042b60;
  border-radius: 10px;
  margin-bottom: 15px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* Add shadow */
}
.btn.btn-cta {
  background-color: #fdc41f;
  border-radius: 4rem;
  color: #042b60;
}
.btn.btn-cta:hover,
.btn.btn-cta:focus {
  background-color: #fdc41f;
  border-radius: 4rem;
  color: #042b60;
}
.page-header {
  background-color: #042b60;
  color: #fff;
  border-radius: 5px 5px 0 0;
  padding: 30px;
  border-bottom: 0;
}
.page-header__logo {
  float: left;
}

.edge-spacing {
  margin-left: 16px;
  margin-right: 16px;
}

.icons-footer-style a {
  font-size: 32px;
  align-items: center;
  color: white;
}

.all-footer-container {
  align-items: start;
}

.footer-logo {
  width: 240px;
}

.header-row {
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: start;
}

@media (max-width: 768px) {
  .header-row {
    grid-template-columns: 1fr; /* Change to a single column layout */
    grid-template-rows: auto auto; /* Define rows for the items */
  }

  .header-row img {
    display: none; /* Hide the image on mobile devices */
  }

  .button-container {
    flex-direction: column;
    margin-top: 2rem; /* Stack buttons vertically on mobile */
  }
  .btn-secondary {
    margin: 0.5rem 3rem; /* Adjust margins for vertical stacking */
  }
  .page-header__title {
    text-align: center;
    margin-left: 0 !important;
    padding: 0 !important; /* Prevent text from wrapping */
    margin-top: 2.5rem !important;
  }
  .form-control {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .form-control.btn-group.is-valid {
    background-image: none;
  }
  .btn-outline-secondary.custom-active:active,
  .btn-outline-secondary.custom-active.active,
  .btn-outline-secondary.custom-active:focus,
  .btn-outline-secondary.custom-active:focus:active,
  .btn-outline-secondary.custom-active:hover {
    color: #042b60; /* Text color */
    background-color: #fdc41f; /* Background color */
    border-color: #fdc41f; /* Border color */
  }
  .btn {
    border: 1px solid #fdc41f !important;
    border-radius: 10px !important;
  }
}

/* This section needs to be updated */

.btn-secondary {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
  background-color: #fdc41f !important;
  border-color: #fdc41f !important;
  border-radius: 6rem !important;
  color: #042b60 !important;
}

.btn-outline-secondary.custom-active:active,
.btn-outline-secondary.custom-active.active,
.btn-outline-secondary.custom-active:focus,
.btn-outline-secondary.custom-active:focus:active,
.btn-outline-secondary.custom-active:hover {
  color: #042b60; /* Text color */
  background-color: #fdc41f; /* Background color */
  border-color: #fdc41f; /* Border color */
}

.p-title {
  font-size: 1.35em;
  font-weight: 500;
  color: #033878;
  margin-bottom: 1rem;
  text-align: center;
  width: 100%;
}
.shorter-p-border {
  scale: 0.6;
  padding-bottom: 0.25rem;
  height: 1px;
  width: 100%; /* Adjust the width as needed */
  margin: 0 auto;
  background-image: linear-gradient(to right, white 2%, #fdc41f 50%, white 98%);
}

.p-content {
  margin-top: 1.5rem;
  text-align: center;
  font-size: 1.1em;
  font-weight: 400;
  color: #033878;
}

.heading-title-style {
  font-size: 2.2em;
  font-weight: 500;
  color: #033878;
}

.page-header__title {
  font-size: 20px;
  font-weight: 300;
  font-family: "WeiterSans", sans-serif;
  float: left;
  margin: 6px 0 0 16px;
  padding: 6px 6px 6px 16px;
  border-left: 1px solid color(#266cb4 shade(40%));
}
.page-header__meta {
  list-style: none;
  margin: 0;
  padding: 0;
}
.page-header__meta svg {
  color: color(#266cb4 shade(40%));
  margin-right: 2px;
  font-size: 20px;
}
.page-header__meta > li {
  display: inline-block;
  margin-right: 15px;
  font-size: 16px;
}
.page-header__meta > li:last-child {
  margin-right: 0;
}
.page-header__content {
  text-align: center;
  margin: 60px 0 60px;
  font-size: 18px;
}
.page-header__content blockquote {
  padding: 0;
  border: 0;
  font-family: Georgia, Times New Roman;
  font-size: 21px;
  font-style: italic;
  font-weight: 400;
  position: relative;
  display: inline-block;
  text-align: center;
  margin-bottom: 30px;
}
.page-header__content blockquote::before {
  content: "“";
  position: absolute;
  font-size: 2.5em;
  top: -0.15em;
  left: -0.75em;
  color: color(#266cb4 shade(40%));
}
.page-header__content small {
  color: color(#fff a(50%));
}
.heading {
  margin-bottom: 1em;
}
.label-left {
  margin-right: 15px;
  font-size: 14px;
}
.label-right {
  color: #042b60;
  margin-left: 15px;
  font-size: 14px;
}
.page-main {
  background-color: #fff;
  padding: 30px;
}
.introduction {
  margin: 15px 0 40px 0;
}
.introduction p:last-child {
  margin-bottom: 0;
}

.icon-color {
  color: #50bcbc;
}

.course-box {
  background-color: #f1f8f7;
  color: #333;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 30px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.1);
  transition: box-shadow 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}
.course-box:hover {
  box-shadow: 0 12px 26px rgba(0, 0, 0, 0.24), 0 8px 8px rgba(0, 0, 0, 0.2);
}
.course-box.active {
  background-color: #fdc41f;
}
.course-box.active .label-default {
  color: #fdc41f;
}
.course-box__trainer {
  color: #333;
}

.course-box__title {
  color: #033878;
  margin: 0 0 10px 0;
  display: block;
  font-size: 17px;
  font-weight: 500;
}

.header-icon-style {
  color: #fdc41f;

  padding-right: 6px;
}

.ct-style,
.cr-style,
.cd-style {
  color: #033878;
}

.course-box__meta {
  list-style: none;
  margin: 0;
  padding: 0;
}
.course-box__meta i {
  width: 25px;
  text-align: center;
}
.page-footer {
  background-color: #042b60;
  color: #e6ebf2;
  border-radius: 0 0 5px 5px;
  padding: 30px 30px;
  margin-bottom: 40px;
}
.has-error.has-feedback .btn {
  border-color: #a94442;
}
.has-error.has-feedback .btn,
.has-error.has-feedback .label-right,
.has-error.has-feedback .label-left {
  color: #a94442;
}
.has-success.has-feedback .btn {
  border-color: #3c763d;
}
.has-success.has-feedback .btn,
.has-success.has-feedback .label-right,
.has-success.has-feedback .label-left {
  color: #3c763d;
}
.has-success.has-feedback label {
  color: #3c763d;
}
.has-error.has-feedback label {
  color: #a94442;
}
.comment-field__control {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-bottom: 0;
}
.comment-field .progress {
  background-color: #ccc;
  height: 5px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  margin-bottom: 0px;
}
.comment-field__progress {
  width: 100%;
  border-bottom-left-radius: 0.25em;
  border-bottom-right-radius: 0.25em;
  font-size: 13px;
  position: relative;
}
.satisfaction-scale {
  display: inline-block;
}
.satisfaction-scale .scale-icons {
  width: 100%;
  display: table;
  margin: 0 0 10px;
  padding: 0;
  list-style: none;
}
.satisfaction-scale .scale-icons__item {
  display: table-cell;
  font-size: 20px;
}
.satisfaction-scale .scale-icons__item--sad {
  color: #c9302c;
  text-align: left;
}
.satisfaction-scale .scale-icons__item--mediocre {
  color: #ec971f;
  text-align: center;
}
.satisfaction-scale .scale-icons__item--happy {
  color: #449d44;
  text-align: right;
}
.starrr .fa {
  font-size: 30px;
}
.starrr-hidden {
  visibility: hidden;
  position: absolute;
  height: 0px;
}
.starrr .fa {
  cursor: pointer;
}
.well-tip {
  color: #042b60;
  font-size: 0.8em;
  margin-bottom: 0px;
}
.well-tip p {
  margin-bottom: 5px;
}
.well-tip p:last-child {
  margin-bottom: 0px;
}
.well-tip ul {
  padding-left: 15px;
}
.char-count {
  position: absolute;
  width: 90%;
  bottom: 10px;
  opacity: 0;
  left: 0;
  right: 0;
  margin: auto;
  border-radius: 8px;
  padding: 5px 15px;
  font-size: 14px;
  font-weight: bold;
  transition: opacity 0.3s ease-in-out;
}
.has-feedback.has-error .char-count.active {
  bottom: 35px;
}
.char-count.active {
  opacity: 1;
}
.comment-field {
  position: relative;
}
.form-sub {
  background: #f1f8f7;
  margin-bottom: 30px;
  padding: 30px;
  border-radius: 10px;
}
.form-sub fieldset {
  margin: 0;
}
.nl-promo {
  background-size: cover;
  margin-bottom: 30px;
  position: relative;
}
.nl-promo::after {
  content: "";
  clear: both;
  display: block;
}
.nl-promo__cover {
  width: 50%;
  float: left;
  border-radius: 5px 5px 0 0;
}
.nl-promo__block {
  width: 50%;
  float: left;
  padding: 19px;
  border-radius: 0 0 5px 5px;
  font-size: 14px;
}
.nl-promo__badge {
  background-color: #fdc41f;
  width: 70px;
  height: 70px;
  border-radius: 100%;
  padding-top: 18px;
  text-align: center;
  color: #fff;
  font-size: 11px;
  position: absolute;
  top: 19px;
  left: 38%;
}
@media (max-width: 700px) {
  .nl-promo__cover {
    width: 100%;
  }
  .nl-promo__block {
    width: 100%;
  }
  .nl-promo__badge {
    right: 17px;
    left: initial;
  }
}
.nl-features {
  margin: 0;
  padding: 0;
  list-style: none;
  counter-reset: section;
}
.nl-features__item {
  position: relative;
  border-left: 2px solid #ccc;
  padding: 0 0 15px 45px;
  margin-left: 32px;
}
.nl-features__item::after {
  content: url("data:image/svg+xml,%3Csvg%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%20viewBox%3D%220%200%2016%2016%22%20xml%3Aspace%3D%22preserve%22%20width%3D%2216%22%20height%3D%2216%22%3E%3Cg%20class%3D%22nc-icon-wrapper%22%20fill%3D%22%23cccccc%22%3E%3Cpolygon%20fill%3D%22%23cccccc%22%20points%3D%228%2C12.6%200.3%2C4.9%201.7%2C3.4%208%2C9.7%2014.3%2C3.4%2015.7%2C4.9%20%22%3E%3C%2Fpolygon%3E%3C%2Fg%3E%3C%2Fsvg%3E");
  width: 16px;
  height: 16px;
  position: absolute;
  bottom: 11px;
  left: -9px;
}
.nl-features__item:last-child {
  border-left: none;
}
.nl-features__item:last-child::after {
  display: none;
}
.nl-features__count {
  background-color: #f77635;
  width: 20px;
  height: 20px;
  display: inline-block;
  position: absolute;
  bottom: 10px;
  right: -10px;
  border-radius: 50%;
  font-size: 12px;
  color: #fff;
  text-align: center;
  line-height: 20px;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.08);
}
.nl-features__count::after {
  content: counter(section);
  counter-increment: section;
}
.nl-features__item:last-child .nl-features__count {
  bottom: 0;
}
.nl-features__icon {
  background-color: #fff;
  position: absolute;
  left: 0;
  padding: 15px 0;
  margin-top: -15px;
  transform: translateX(-50%);
}
.nl-features__item:first-child .nl-features__icon {
  padding-top: 0;
  margin-top: 0;
}
.nl-features__item:last-child .nl-features__icon {
  padding-bottom: 0;
}
.nl-features__title {
  margin: 0 0 15px 0;
  padding-top: 7px;
}
.copy-mail {
  font-size: 12px;
  line-height: 14px;
  overflow: hidden;
  padding: 2px 10px;
}
/*! CSS Used from: https://www.gfu.net/css/styles2.css?v=72c7bd7bd7ce84cd35003f68844423ff */
.fa {
  display: inline-block;
  font: normal normal normal 14px/1 FontAwesome;
  font-size: inherit;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.course-box__meta li > svg {
  width: 20px;
}
.fa-star:before {
  content: "";
}
svg {
  fill: currentColor;
}
.card {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
}
.card-rating {
  margin-bottom: 1rem;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
}
.card-rating .quotation {
  width: 24px;
  height: 24px;
  fill: #266cb4;
  margin-top: -10px;
}
.card-rating .card-text {
  margin-top: 0.5rem;
  margin-bottom: 0;
}
.card-rating .card-body {
  margin-bottom: 1rem;
}
.card-rating .rating-stars {
  height: 24px;
  line-height: 24px;
  font-size: 0.9rem;
  float: right;
}
.card-rating::after {
  content: "";
  background-color: #fff;
  width: 1rem;
  height: 1rem;
  position: absolute;
  bottom: -0.5rem;
  left: 1.25rem;
  transform: rotate(45deg);
}
.comment-field {
  margin-bottom: 20px;
}
a.disabled {
  cursor: not-allowed;
}
a.disabled .course-box {
  box-shadow: none;
}
</style>
